import {createContext, useContext, ReactNode} from 'react';
import type {RepairData, GroupData} from '../features/api/types';

export interface RepairContextValue {
  repair: RepairData;
  group: GroupData;
  dynamicContent: unknown; // Will be properly typed later
  refetch: () => void;
}

interface RepairProviderProps {
  children: ReactNode;
  value: RepairContextValue;
}

const RepairContext = createContext<RepairContextValue | undefined>(undefined);

const RepairProvider = ({children, value}: RepairProviderProps) => {
  return <RepairContext.Provider value={value}>{children}</RepairContext.Provider>;
};

const useRepair = () => {
  const context = useContext(RepairContext);
  if (context === undefined) {
    throw new Error('useRepair must be used within a RepairProvider');
  }
  return context;
};

export {useRepair, RepairProvider};
